import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Trash2, AlertTriangle, X } from 'lucide-react';
import { toast } from 'sonner';
import { api, formatApiError } from '../lib/api';
import { t } from '../lib/i18n';
import { useAuth } from '../context/AuthContext';

const DeleteAccountDialog = ({ onClose }) => {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.delete('/auth/me', { data: { password } });
      await logout();
      onClose();
      navigate('/');
      toast.success(t('Votre compte et vos données ont été supprimés'));
    } catch (err) { toast.error(formatApiError(err)); } finally { setBusy(false); }
  };
  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center p-4" role="dialog" aria-modal="true" data-testid="delete-account-dialog">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <form onSubmit={submit} className="relative w-full max-w-md rounded-2xl border border-[#262626] bg-[#141414] p-6 text-white shadow-2xl">
        <button type="button" onClick={onClose} aria-label={t('Fermer')} className="absolute top-4 end-4 text-[#808080] hover:text-white" data-testid="delete-account-close"><X size={18} /></button>
        <span className="w-11 h-11 rounded-full bg-red-500/15 text-red-400 flex items-center justify-center"><AlertTriangle size={22} /></span>
        <h2 className="text-xl font-black mt-4">{t('Supprimer mon compte')}</h2>
        <p className="text-sm text-[#B3B3B3] mt-2 leading-relaxed">{t('Cette action supprime définitivement votre compte, vos favoris, votre liste de courses, vos alertes et vos préférences. Cette action est irréversible.')}</p>
        <p className="text-xs text-[#808080] mt-2">{t('Les comptes annonceurs avec factures sont anonymisés : les factures sont conservées pour la période légale de 10 ans, toutes les autres données sont effacées.')}</p>
        <label className="block mt-5 text-xs font-bold uppercase tracking-wider text-[#808080]">{t('Confirmez avec votre mot de passe')}</label>
        <input type="password" required autoFocus value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" data-testid="delete-account-password"
          className="mt-1.5 w-full h-11 px-3 rounded-lg bg-black border border-[#262626] text-white text-sm focus:outline-none focus:border-red-500" />
        <div className="mt-5 flex gap-2 justify-end">
          <button type="button" onClick={onClose} className="h-10 px-4 rounded-full border border-[#262626] text-sm font-semibold text-[#B3B3B3] hover:text-white" data-testid="delete-account-cancel">{t('Annuler')}</button>
          <button type="submit" disabled={busy || !password} className="h-10 px-4 rounded-full bg-red-600 hover:bg-red-500 disabled:opacity-50 text-sm font-bold inline-flex items-center gap-2" data-testid="delete-account-confirm">
            {busy ? <Loader2 size={15} className="animate-spin" /> : <Trash2 size={15} />} {t('Supprimer définitivement')}
          </button>
        </div>
      </form>
    </div>
  );
};

export default DeleteAccountDialog;
